<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="bg-gray-100 rounded shadow-xs border border-gray-200">
    <div class="p-4 bg-gray-200 text-lg">
      {{ title }}
    </div>
    <div
      class="overflow-y-auto"
      style="max-height: 800px"
    >
      <slot />
    </div>
  </div>
</template>
